/** Set when the user completes an impersonation magic link; cleared on sign-out. */
export const IMPERSONATION_SESSION_KEY = 'dms-impersonation-active';

export function setImpersonationActive(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(IMPERSONATION_SESSION_KEY, '1');
}

export function clearImpersonation(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(IMPERSONATION_SESSION_KEY);
}

export function isImpersonationActive(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(IMPERSONATION_SESSION_KEY) === '1';
}
